import React from 'react';
import { Input, Select, Radio, Checkbox, Row, Col, DatePicker, Icon } from 'antd';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
import moment from 'moment';
const { Option } = Select;
const InputGroup = Input.Group;

export default class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16} align="middle">
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            mode="year"
                            format="YYYY"
                            value={
                                this.props.filter.fechaInicioStr
                                    ? moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')
                                    : null
                            }
                            disabledDate={current =>
                                current && current.year() > moment().year()
                            }
                            clearIcon={false}
                            onPanelChange={(value) => {
                                this.props.onChange(
                                    'fechaInicioStr',
                                    `01/01/${value.format('YYYY')}`
                                );
                            }}
                        />
                    </Col>
    
                    <Col className="gutter-row" sm={24} md={12} lg={7}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.referencia}
                            onChange={(e) => this.props.onChange("referencia", e.target.value)}
                            placeholder="Filtrar por serie"
                            autoComplete="off"
                        />
                    </Col>


                </Row>

            </div>
        );
    }
}